<template>
    <div class ="proposal">
        <div class="header">
            <div class="users">
                <div class="ava avatar">
                    <div class="avatars">
                        <img src="../../../assets/pro/avatar2x.png"/>
                    </div>
                    <div class="inform">
                        <div class="title">Welcome to the proposal community</div>
                        <div class="note">You can vote after logging in</div>
                    </div>
                </div>
                <div class=" sign">
<!--                    <div class = "signs left" @click="Login">Sign in</div>-->
<!--                    <div class = "signs" @click="Register">Sign up</div>-->
                    <div class = "signs" @click="bindWallet">wallet</div>
                    <div class = "signs" @click="publish">+ proposal</div>
                </div>
            </div>
            <div class="search">
                <div class="searchFor">
                    <van-search name="search" v-model="searchValue" placeholder="Search" background="#FFFFF"/>

                    <!--                  <img />-->
                    <!--                  <el-input  placeholder="Search" prefix-icon="el-icon-search"></el-input>-->
                </div>
                <div class="options">
                    <div class="option">All</div>
                    <div class="option">In the discussion</div>
                    <div class="option">In the voting</div>
                    <div class="option">In the action</div>
                    <div class="option">In the closing</div>
                    <div class="option">Done</div>
                    <div class="option">Reject</div>
                </div>

            </div>
        </div>

        <div class="content">
            <div class="proposals">

                <div class = "item">
                    <van-collapse  v-model="activeName"  accordion>
                        <van-collapse-item name="1">
                            <template #title>
                                <div class="brief">
                                    <div class="title"> Overview</div>
                                    <div class="content"> Complete the following...</div>
                                </div>
                                <div class="brief">
                                    <div class="title"> Proposer</div>
                                    <div class="content">Risckal</div>
                                </div>
                                <div class="brief">
                                    <div class="title"> Creation time</div>
                                    <div class="content">2020-04-07</div>
                                </div>
                                <div class="status">
                                    <img src="../../../assets/pro/reject.png"/>
                                    In the voting
                                </div>
                                <div class="progress1"> </div>
                            </template>

                           <div class="intro">
                               <div class="title">Overview</div>
                               <div class="content">
                                   Tian Dynasty did not pull the moon between the whole system of the mine from the light call after the release of nine good pieces of fixed confidence to go from each pedestal to each habit of the more contentious by heavy layer road and other extreme theory of a few short-matter sound can often be white also home to recognize you. Knowledge with a sense of war thinking called the number of turn should be empty law pack eye period of each head strong also set alive do you have full water before the voice away. Each special back and the universal law but concerned about opening a white and very careful people to the labor speed will cure the heart from the first anti-rowing called long dragon man book title quasi-put every her.
                               </div>
                               </div>
                            <div class="intro">
                                <div class="title">Objective</div>
                                <div class="content">
                                    Tian Dynasty did not pull the moon between the whole system of the mine from the light call after the release of nine good pieces of fixed confidence to go from each pedestal to each habit of the more contentious by heavy layer road and other extreme theory of a few short-matter sound can often be white also home to recognize you. Knowledge with a sense of war thinking called the number of turn should be empty law pack eye period of each head strong also set alive do you have full water before the voice away. Each special back and the universal law but concerned about opening a white and very careful people to the labor speed will cure the heart from the first anti-rowing called long dragon man book title quasi-put every her.
                                </div>
                            </div>
                            <div class="intro">
                                <div class="title">Plan</div>
                                <div class="content">
                                    Tian Dynasty did not pull the moon between the whole system of the mine from the light call after the release of nine good pieces of fixed confidence

                                </div>
                            </div>
                            <div class="intro">
                                <div class="title">Budget</div>
                                <div class="content">
                                    Tian Dynasty did not pull the moon between the whole system of the mine from the light call after the release of nine good pieces of fixed
                                </div>
                            </div>
                            <div class="intro">
                                <div class="title">Implementation plan</div>
                                <div class="content">
                                    Tian Dynasty did not pull the moon between the whole system of the mine from the light call after the release of nine good pieces of fixed
                                </div>
                            </div>
                            <div class="intro1">
                                <div class="title">Progress 1</div>
                                <div class="content">
                                    Tian Dynasty did not pull the moon between the whole system of the mine from the light call after the release of nine good pieces of fixed confidence to go Tian Dynasty did not pull the moon between the whole system of the mine from the light call after the release of nine good pieces of fixed confidence

                                </div>
                            </div>
                            <div class="intro1">
                                <div class="title">Progress 2</div>
                                <div class="content">
                                    Tian Dynasty did not pull the moon between the whole system of the mine from the light call after the release of nine good pieces of fixed confidence to go Tian Dynasty did not pull the moon between the whole system of the mine from the light call after the release of nine good pieces of fixed confidence

                                </div>
                            </div>
                            <div class="progress">
                                <div class="step">
                                    <div class="left"
                                            v-show="leftPercent"
                                            :class="[{ 'full-left': !rightPercent }, { 'tringle': rightPercent }]"
                                            :style="{ width: leftPercent+'%' }"

                                    ></div>
                                    <div class="right"
                                            v-show="rightPercent"
                                            :class="[{ 'full-right': !leftPercent }]"

                                    > </div>
                                </div>
                                <div class="zan">
                                    <div class="left favor">
                                        <van-icon name="good-job-o" />
                                        8
                                    </div>
                                    <div class="right opposition">
                                        <van-icon name="good-job-o" />
                                        2
                                    </div>
                                </div>
                            </div>
                        </van-collapse-item>
                    </van-collapse>

                </div>

                <div class = "item">
                    <van-collapse  v-model="activeName"  accordion>
                        <van-collapse-item  name="2">
                            <template #title>
                                <div class="brief">
                                    <div class="title"> Overview</div>
                                    <div class="content"> Complete the following...</div>
                                </div>
                                <div class="brief">
                                    <div class="title"> Proposer</div>
                                    <div class="content">Risckal</div>
                                </div>
                                <div class="brief">
                                    <div class="title"> Creation time</div>
                                    <div class="content">2020-04-07</div>
                                </div>
                                <div class="status">
                                    <img src="../../../assets/pro/reject.png"/>
                                    In the voting
                                </div>
                                <div class="progress1"> </div>
                            </template>

                            <div class="intro">
                                <div class="title">Overview</div>
                                <div class="content">
                                    Tian Dynasty did not pull the moon between the whole system of the mine from the light call after the release of nine good pieces of fixed confidence to go from each pedestal to each habit of the more contentious by heavy layer road and other extreme theory of a few short-matter sound can often be white also home to recognize you. Knowledge with a sense of war thinking called the number of turn should be empty law pack eye period of each head strong also set alive do you have full water before the voice away. Each special back and the universal law but concerned about opening a white and very careful people to the labor speed will cure the heart from the first anti-rowing called long dragon man book title quasi-put every her.
                                </div>
                            </div>
                            <div class="intro">
                                <div class="title">Objective</div>
                                <div class="content">
                                    Tian Dynasty did not pull the moon between the whole system of the mine from the light call after the release of nine good pieces of fixed confidence to go from each pedestal to each habit of the more contentious by heavy layer road and other extreme theory of a few short-matter sound can often be white also home to recognize you. Knowledge with a sense of war thinking called the number of turn should be empty law pack eye period of each head strong also set alive do you have full water before the voice away. Each special back and the universal law but concerned about opening a white and very careful people to the labor speed will cure the heart from the first anti-rowing called long dragon man book title quasi-put every her.
                                </div>
                            </div>
                            <div class="intro">
                                <div class="title">Plan</div>
                                <div class="content">
                                    Tian Dynasty did not pull the moon between the whole system of the mine from the light call after the release of nine good pieces of fixed confidence

                                </div>
                            </div>
                            <div class="intro">
                                <div class="title">Budget</div>
                                <div class="content">
                                    Tian Dynasty did not pull the moon between the whole system of the mine from the light call after the release of nine good pieces of fixed
                                </div>
                            </div>
                            <div class="intro">
                                <div class="title">Implementation plan</div>
                                <div class="content">
                                    Tian Dynasty did not pull the moon between the whole system of the mine from the light call after the release of nine good pieces of fixed
                                </div>
                            </div>
                            <div class="intro1">
                                <div class="title">Progress 1</div>
                                <div class="content">
                                    Tian Dynasty did not pull the moon between the whole system of the mine from the light call after the release of nine good pieces of fixed confidence to go Tian Dynasty did not pull the moon between the whole system of the mine from the light call after the release of nine good pieces of fixed confidence

                                </div>
                            </div>
                            <div class="intro1">
                                <div class="title">Progress 2</div>
                                <div class="content">
                                    Tian Dynasty did not pull the moon between the whole system of the mine from the light call after the release of nine good pieces of fixed confidence to go Tian Dynasty did not pull the moon between the whole system of the mine from the light call after the release of nine good pieces of fixed confidence

                                </div>
                            </div>
                            <div class="progress">
                                <div class="step">
                                    <div class="left"
                                         v-show="leftPercent"
                                         :class="[{ 'full-left': !rightPercent }, { 'tringle': rightPercent }]"
                                         :style="{ width: leftPercent+'%' }"

                                    ></div>
                                    <div class="right"
                                         v-show="rightPercent"
                                         :class="[{ 'full-right': !leftPercent }]"

                                    > </div>
                                </div>
                                <div class="zan">
                                    <div class="left favor">
                                        <van-icon name="good-job-o" />
                                        8
                                    </div>
                                    <div class="right opposition">
                                        <van-icon name="good-job-o" />
                                        2
                                    </div>
                                </div>
                            </div>
                        </van-collapse-item>
                    </van-collapse>

                </div>
                <div class = "item">
                    <van-collapse  v-model="activeName"  accordion>
                        <van-collapse-item  name="3">
                            <template #title>
                                <div class="brief">
                                    <div class="title"> Overview</div>
                                    <div class="content"> Complete the following...</div>
                                </div>
                                <div class="brief">
                                    <div class="title"> Proposer</div>
                                    <div class="content">Risckal</div>
                                </div>
                                <div class="brief">
                                    <div class="title"> Creation time</div>
                                    <div class="content">2020-04-07</div>
                                </div>
                                <div class="status">
                                    <img src="../../../assets/pro/reject.png"/>
                                    In the voting
                                </div>
                                <div class="progress1"> </div>
                            </template>

                            <div class="intro">
                                <div class="title">Overview</div>
                                <div class="content">
                                    Tian Dynasty did not pull the moon between the whole system of the mine from the light call after the release of nine good pieces of fixed confidence to go from each pedestal to each habit of the more contentious by heavy layer road and other extreme theory of a few short-matter sound can often be white also home to recognize you. Knowledge with a sense of war thinking called the number of turn should be empty law pack eye period of each head strong also set alive do you have full water before the voice away. Each special back and the universal law but concerned about opening a white and very careful people to the labor speed will cure the heart from the first anti-rowing called long dragon man book title quasi-put every her.
                                </div>
                            </div>
                            <div class="intro">
                                <div class="title">Objective</div>
                                <div class="content">
                                    Tian Dynasty did not pull the moon between the whole system of the mine from the light call after the release of nine good pieces of fixed confidence to go from each pedestal to each habit of the more contentious by heavy layer road and other extreme theory of a few short-matter sound can often be white also home to recognize you. Knowledge with a sense of war thinking called the number of turn should be empty law pack eye period of each head strong also set alive do you have full water before the voice away. Each special back and the universal law but concerned about opening a white and very careful people to the labor speed will cure the heart from the first anti-rowing called long dragon man book title quasi-put every her.
                                </div>
                            </div>
                            <div class="intro">
                                <div class="title">Plan</div>
                                <div class="content">
                                    Tian Dynasty did not pull the moon between the whole system of the mine from the light call after the release of nine good pieces of fixed confidence

                                </div>
                            </div>
                            <div class="intro">
                                <div class="title">Budget</div>
                                <div class="content">
                                    Tian Dynasty did not pull the moon between the whole system of the mine from the light call after the release of nine good pieces of fixed
                                </div>
                            </div>
                            <div class="intro">
                                <div class="title">Implementation plan</div>
                                <div class="content">
                                    Tian Dynasty did not pull the moon between the whole system of the mine from the light call after the release of nine good pieces of fixed
                                </div>
                            </div>
                            <div class="intro1">
                                <div class="title">Progress 1</div>
                                <div class="content">
                                    Tian Dynasty did not pull the moon between the whole system of the mine from the light call after the release of nine good pieces of fixed confidence to go Tian Dynasty did not pull the moon between the whole system of the mine from the light call after the release of nine good pieces of fixed confidence

                                </div>
                            </div>
                            <div class="intro1">
                                <div class="title">Progress 2</div>
                                <div class="content">
                                    Tian Dynasty did not pull the moon between the whole system of the mine from the light call after the release of nine good pieces of fixed confidence to go Tian Dynasty did not pull the moon between the whole system of the mine from the light call after the release of nine good pieces of fixed confidence

                                </div>
                            </div>
                            <div class="progress">
                                <div class="step">
                                    <div class="left"
                                         v-show="leftPercent"
                                         :class="[{ 'full-left': !rightPercent }, { 'tringle': rightPercent }]"
                                         :style="{ width: leftPercent+'%' }"

                                    ></div>
                                    <div class="right"
                                         v-show="rightPercent"
                                         :class="[{ 'full-right': !leftPercent }]"

                                    > </div>
                                </div>
                                <div class="zan">
                                    <div class="left favor">
                                        <van-icon name="good-job-o" />
                                        8
                                    </div>
                                    <div class="right opposition">
                                        <van-icon name="good-job-o" />
                                        2
                                    </div>
                                </div>
                            </div>
                        </van-collapse-item>
                    </van-collapse>

                </div>
            </div>
            <div class="pages">
                <el-pagination
                        layout="prev, pager, next"
                        :total="20"
                        :page-size="5"
                        @current-change="handleCurrentChange"
                        :current-page="pageSize"
                >
                </el-pagination>
            </div>
        </div>
<!--        id="dialog"-->
        <div :class="dialogVisible ? 'block dialog' : 'none dialog'"

             :style="`width:100%;height:100%;z-index:999`">
            <div class="details">
                <div class="close" @click="close"><i class="el-icon-close"></i></div>
                <BindWallet   v-if="dialogType == 'bind'" @close="close" ></BindWallet>
            </div>
        </div>
    </div>

</template>

<script>
    import Vue from 'vue';
    import { Collapse, CollapseItem,Search } from 'vant';
    import BindWallet from "./Bindwallet.vue";
    Vue.use(Search).use(Collapse).use(CollapseItem);

    const LEFT_BAR = "left";
    const RIGHT_BAR = "right";
    const SHOW_TIP = "show";
    const HIDE_TIP = "hide";

    export default {
        components: {
            BindWallet,
        },
        data() {
            return {
                dialogVisible:false,
                pageSize: 1,
                total: 0,
                dialogType:"",
                searchValue:"",
                activeName: "",
                LEFT_BAR: LEFT_BAR,
                RIGHT_BAR: RIGHT_BAR,
                SHOW_TIP: SHOW_TIP,
                HIDE_TIP: HIDE_TIP,
                totalNum: 1000,
                leftPercent: 80,
                leftBar: {
                    isShowTip: false,
                    delayOut: null
                },
                rightBar: {
                    isShowTip: false,
                    delayOut: null
                }

            }
        },
        methods:{
            handleCurrentChange (currentPage) {
                this.pageSize = currentPage;
                // this.getVoteList();
            },
            Login(){
                this.$router.push({ name: "Login" });
            },
            Register(){
                this.$router.push({ name: "Register" });
            },
            bindWallet(){
                this.dialogVisible = true;
                this.dialogType = "bind";
            },
            publish(){
                this.$router.push({ name: "Publish" });
            },
            close() {
                console.log(this.dialogVisible)
                this.dialogVisible = false;
                this.dialogType = "";
            },
        },
        computed: {
            rightPercent: function () {
                return 100 - this.leftPercent;
            }
        }
    }
</script>

<style lang="less">
    .van-search__content{
        background-color: #ffffff;
        /*border-bottom: 1px solid #E8E9F0;*/
    }
    .van-search {
        padding: 0 10px;
        margin-bottom: 10px;
        background-color: transparent;
        height: 20px;
        .van-icon{
            color: #4573E7;
        }
    }

    .van-field__left-icon {
        margin-right: 14px;
        margin-left: 15px;
    }
    .van-field__control::-webkit-input-placeholder{/*Webkit browsers*/
        font-size: 14px;
        font-family: Poppins-Medium, Poppins;
        font-weight: 500;
        color: rgba(69, 115, 231, 0.5);
        line-height: 16px;
    }
    .van-cell__title{
        width: 1050px;
        height: 120px;
        background: #FFFFFF;
    }

    .van-collapse{
        .van-cell{

        .van-icon{
            margin-top: 35px;
            margin-right: 30px;
            width: 50px;
            height: 50px;
            background: #EBF0F5;
            opacity: 1;
            text-align: center;
            line-height: 50px;
            border-radius: 50%;
            color:#546690;
            font-size: 18px;
        }
        }

    }


    input::-webkit-input-placeholder{/*Webkit browsers*/
        font-size: 14px;
        font-family: Poppins-Medium, Poppins;
        font-weight: 500;
        color: rgba(69, 115, 231, 0.5);
        line-height: 16px;
    }
    input ::-ms-input-placeholder{/*Webkit browsers*/
        font-size: 14px;
        font-family: Poppins-Medium, Poppins;
        font-weight: 500;
        color: rgba(69, 115, 231, 0.5);
        line-height: 16px;
    }
    input:-moz-placeholder{/*Mozilla Firefox 4 to 8*/
        font-size: 14px;
        font-family: Poppins-Medium, Poppins;
        font-weight: 500;
        color: rgba(69, 115, 231, 0.5);
        line-height: 16px;
    }
    input::-moz-placeholder{/*Mozilla Firefox 19+*/
        font-size: 14px;
        font-family: Poppins-Medium, Poppins;
        font-weight: 500;
        color: rgba(69, 115, 231, 0.5);
        line-height: 16px;
    }
    input:-ms-input-placeholder{/*Internet Explorer 10+*/
        font-size: 14px;
        font-family: Poppins-Medium, Poppins;
        font-weight: 500;
        color: rgba(69, 115, 231, 0.5);
        line-height: 16px;
    }


</style>
<style lang="less" scoped>

    .proposal{
        width: 100%;

    .header{
        margin-top: 85px;
        height: 315px;
        background: #FFFFFF;
        box-shadow: 0px 4px 20px 1px rgba(0, 0, 0, 0.09);
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
        overflow: hidden;
    .users{
        width: 1190px;
        margin: 0 auto;
        padding-top: 70px;
        overflow: hidden;
    .ava{
        float: left;
        width: 400px;
    }
    .avatar{
        display: inline-block;
    .avatars{
        float: left;
        padding-right: 30px;
    img{
        width: 60px;
        height: 60px;
    }
    }
    .inform{
        vertical-align: middle;
        margin: 0 auto;
        font-family: Poppins-SemiBold, Poppins;
    .title{
        font-size: 16px;
        font-weight: 600;
        color: #2C1D1A;
        margin-bottom: 4px;
    }
    .note{
        font-size: 14px;
        font-weight: 500;
        color: rgba(115, 117, 130, 0.5);
    }
    }
    }
    .sign{
        display: inline-block;
        float: right;
        overflow: hidden;
    .signs{
        float: right;
        width: 165px;
        height: 50px;
        background: rgba(235, 240, 245, 0.5);
        border-radius: 25px 25px 25px 25px;
        opacity: 1;
        line-height: 50px;
        text-align: center;
        font-size: 16px;
        font-family: Poppins-SemiBold, Poppins;
        font-weight: 600;
        color: #546690;
    }
    .left{
        margin-left: 40px;
    }
    }
    }
    .search{
        width: 1190px;
        margin: 0 auto;
        padding-top:84px;
        padding-bottom: 30px;
        opacity: 1;
        border-bottom: 1px solid #E8E9F0;
    .searchFor{
        float: left;
        width: 285px;
        font-size: 14px;
        font-family: Poppins-Medium, Poppins;
        font-weight: 500;
        color: rgba(69, 115, 231, 0.5);
        line-height: 16px;
        border-right: 1px solid #E8E9F0;
    img{
        width: 17px;
        height: 17px;
        margin-right: 22px;
        opacity: 1;
        border: 2px solid #4573E7;
    }

    }
    .options{
        text-align: center;
        font-size: 14px;
        font-family: Poppins-Medium, Poppins;
        font-weight: 500;
        color: #999999;
        line-height: 16px;
        .option{
            float: left;
            /*width: 148px;*/
            padding-left: 30px;
            padding-right: 30px;
            opacity: 1;
            border-right: 1px solid #E8E9F0;
        }
        .option::selection{
            color: #4573E7;
        }
    }

    }
    }
    .content{
        text-align: center;
        .proposals{
            text-align: center;
            padding-top: 80px;
            margin: 0 auto;
        .item{
            margin: 0 auto;
            width: 1190px;
            /*height: 120px;*/
            background: #FFFFFF;
            box-shadow: 0px 9px 20px 1px rgba(0, 0, 0, 0.02);
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            border: 1px solid #E8EBF0;
            margin-bottom: 40px;
            .van-cell__title{
                /*width: 1190px;*/
                height: 120px;
                /*background: #FFFFFF;*/
                /*box-shadow: 0px 9px 20px 1px rgba(0, 0, 0, 0.02);*/
                /*border-radius: 10px 10px 10px 10px;*/
                /*opacity: 1;*/
                /*border: 1px solid #E8EBF0;*/
            }


            .brief{
                /*display: flex;*/
                float: left;
                text-align: left;
                margin-top:37px;
                margin-left:30px;
                margin-right:60px;
                .title{
                    font-size: 16px;
                    font-family: Poppins-SemiBold, Poppins;
                    font-weight: 600;
                    color: #2C1D1A;
                    line-height: 19px;
                    margin-bottom: 4px;
                }
                .content{
                    float: left;
                    font-size: 14px;
                    font-family: Poppins-Medium, Poppins;
                    font-weight: 500;
                    color: rgba(115, 117, 130, 0.5);
                    line-height: 16px;
                }
            }
            .status{
                margin-top:49px;
                float: left;
                margin-left: 40px;
                margin-right: 20px;
                font-size: 14px;
                font-family: Poppins-Medium, Poppins;
                font-weight: 500;
                color: #4573E7;
                width: 120px;
                line-height: 16px;
                img{
                    width: 12px;
                    height: 12px;
                    opacity: 1;
                    margin-right: 10px;
                }
            }
            .progress1{
                float: left;
                margin-top: 55px;
                width: 250px;
                height: 10px;
                background: #EBF0F5;
                border-radius: 10px 10px 10px 10px;
                opacity: 1;
            }
            i .van-icon{
                width: 50px;
                height: 50px;
                background: #EBF0F5;
                opacity: 1;
            }

            .intro {
                text-align:left;
                margin-left:40px;
                margin-right:40px;
                .title{
                    font-size: 18px;
                    font-family: Poppins-SemiBold, Poppins;
                    font-weight: 600;
                    color: #2C1D1A;
                    line-height: 21px;
                    margin-bottom: 10px;
                }
                .content{
                    text-align:left;
                    font-size: 14px;
                    font-family: Poppins-Medium, Poppins;
                    font-weight: 500;
                    color: #737582;
                    line-height: 35px;
                    margin-bottom: 30px;
                }
            }
            .intro1{
                /*width: 1110px;*/
                /*height: 150px;*/
                margin-left:40px;
                margin-right:40px;
                background: #FAFAFA;
                border-radius: 0px 0px 0px 0px;
                opacity: 1;
                margin-bottom: 20px;
                .title{
                    margin-left: 20px;
                    padding-top: 20px;
                    text-align:left;
                    font-size: 18px;
                    font-family: Poppins-SemiBold, Poppins;
                    font-weight: 600;
                    color: #2C1D1A;
                    line-height: 21px;
                    margin-bottom: 10px;
                }
                .content{
                    text-align:left;
                    font-size: 14px;
                    margin-left: 20px;
                    margin-right: 20px;
                    padding-bottom: 23px;
                    font-family: Poppins-Medium, Poppins;
                    font-weight: 500;
                    color: #737582;
                    line-height: 35px;
                }
            }
            .progress{
                margin-left:40px;
                margin-right:40px;
                margin-top:50px;
                .step {
                    display: flex;
                    width: 100%;
                    font-size: 0;
                    .left {
                        flex-grow: 0;
                        position: relative;
                        display: inline-block;
                        background: #4573E7;
                        color: #fff;
                        text-align: center;
                        font-weight: bold;
                        width: 70%;
                        font-size: 12px;
                        line-height: 20px;
                        height: 20px;
                        min-width: 30px;
                        border-top-left-radius: 5px;
                        border-bottom-left-radius: 5px;
                    }
                    /* 百分百的时候不显示该伪类*/
                    .tringle::after {
                        content: " ";
                        position: absolute;
                        top: 0;
                        right: -8px;
                        border-width: 20px 8px;
                        border-style: solid;
                        border-color: #4573E7 transparent transparent transparent;
                        z-index: 10;
                    }
                    .right {
                        flex-grow: 1;
                        position: relative;
                        display: inline-block;
                        background: #E10475;
                        color: #333;
                        font-weight: bold;
                        text-align: center;
                        font-size: 12px;
                        line-height: 20px;
                        height: 20px;
                        text-align: center;
                        min-width: 35px;
                        border-top-right-radius: 5px;
                        border-bottom-right-radius: 5px;
                    }
                    .full-left{
                        border-top-right-radius: 5px;
                        border-bottom-right-radius: 5px;
                    }
                    .full-right{
                        border-top-left-radius: 5px;
                        border-bottom-left-radius: 5px;
                    }
                }
            .zan{
                display: flex;
                width: 100%;
                font-size: 18px;
                font-family: Poppins-SemiBold, Poppins;
                font-weight: 600;
                color: rgba(69, 115, 231, 0.15);
                line-height: 21px;
                .vant-icon{
                    /*width: 23px;*/
                    /*height: 22px;*/
                    background: rgba(69, 115, 231, 0.15);
                    opacity: 1;
                }
                .left{
                    margin-top: 15px;
                    margin-left: 10px;
                    width: 50%;
                    float: left;
                    text-align: left;
                }
                .right{
                    margin-top: 15px;
                    margin-right: 10px;
                    width: 50%;
                    float: right;
                    text-align: right;
                }

            }
            }
        }
    }
    .pages{
        margin-top: 80px;
        margin-bottom: 242px;
    }

    }
    .none {
        display: none;
    }
    .block {
        display: flex;
    }
    .dialog {
            position: fixed;
            left: 0;
            top: 0;
            z-index: 999 !important;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            justify-content: center;
            align-items: center;
        .details {
            width: 1190px;
            height: 614px;
            background: #fff;
            position: relative;
            border-radius: 10px;
            color: #000;
            box-sizing: border-box;
            z-index: 10000;
        .close {
            position: absolute;
            right: 32px;
            top: 32px;
            font-size: 26px;
            cursor: pointer;
            color: #305bbc;
        }
        }
    }
    }


</style>
